import { Cards } from '../models/upgrades.interfaces';

export const Card01Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-beverages.svg',
    alt: 'Drink Vouchers image'
  },
  link: {
    label: 'Redeem',
    url: '/myprofile/certificates'
  },
  label: '4',
  title: 'Drink Vouchers',
  type: '1'
};

export const Card02Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-certificates.svg',
    alt: 'Certificates & eCredits image'
  },
  link: {
    label: 'Redeem',
    url: '/edocs/redeem-documents'
  },
  label: '3',
  title: 'Certificates & eCredits',
  type: '2'
};

export const Card03Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-delta-premium.svg',
    alt: '20% Off Delta Premium Select image'
  },
  link: {
    label: 'Redeem',
    url: 'https://www.delta.com/edocs/redeem-documents'
  },
  label: '2',
  title: '20% Off Delta Premium Select',
  type: '3'
};

export const Card04Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-choice-benefits-certificate.svg',
    alt: 'Global & Regional Upgrade Certificate image'
  },
  link: {
    label: 'Redeem',
    url: 'http://placeimg.com/100/100/tech'
  },
  tag: 'Choice Benefit',
  title: 'Global & Regional Upgrade Certificate',
  type: '4'
};

export const Card05Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-travel-voucher.svg',
    alt: '$200 Travel Voucher image'
  },
  link: {
    label: 'Redeem',
    url: 'http://placeimg.com/100/100/tech'
  },
  tag: 'Choice Benefit',
  title: '$200 Travel Voucher',
  type: '5'
};

export const Card06Mocks: Cards = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/upgrades/elevate-choice-benefits-gold.svg',
    alt: 'Give Gold Medallion Status image'
  },
  link: {
    label: 'Redeem',
    url: 'http://placeimg.com/100/100/tech'
  },
  tag: 'Choice Benefit',
  title: 'Give Gold Medallion Status',
  type: '6'
};
